import React, { Suspense, lazy, useState } from 'react';
import { A11yFloatingPanel } from './A11yFloatingPanel.jsx';
import { KeyboardHelpModal } from './KeyboardHelpModal.jsx';
import { useGlobalShortcuts } from '../hooks/useGlobalShortcuts.js';

const LazyDyslexiaFontLoader = lazy(() =>
  import('./DyslexiaFontLoader.jsx').then((m) => ({ default: m.DyslexiaFontLoader }))
);
const LazyReadingGuide = lazy(() =>
  import('./ReadingGuide.jsx').then((m) => ({ default: m.ReadingGuide }))
);

export function A11yShell() {
  const [helpOpen, setHelpOpen] = useState(false);

  useGlobalShortcuts({
    onHelp: () => setHelpOpen(true),
    onSkipToMain: () => {
      if (typeof document === 'undefined') return;
      const el = document.getElementById('main');
      if (!el) return;
      try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (err) {  } }
      if (typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'start' });
    },
  });

  return (
    <>
      <Suspense fallback={null}>
        <LazyDyslexiaFontLoader />
        <LazyReadingGuide />
      </Suspense>
      <A11yFloatingPanel onOpenHelp={() => setHelpOpen(true)} />
      <KeyboardHelpModal open={helpOpen} onClose={() => setHelpOpen(false)} />
    </>
  );
}

export default A11yShell;
